import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#3FAE2A',
    light: '#B8FBF0',
    dark: '#2B7A20',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#00ABC7',
    light: '#03a9f4',
    dark: '#0288d1',
    contrastText: '#ffffff',
  },
  error: {
    main: '#DC0C0C',
    light: '#FFECFC',
    dark: '#9D0F41',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f7b217',
    light: '#FFE082',
    dark: '#e65100',
    contrastText: '#ffffff',
  },
  info: {
    main: '#00ABC7',
    light: '#03a9f4',
    dark: '#0288d1',
    contrastText: '#ffffff',
  },
  success: {
    main: '#1b9e43',
    light: '#4caf50',
    dark: '#1b5e20',
    contrastText: '#ffffff',
  },
  grey: {
    50: '#F7F9FC',
    100: '#EFF3F6',
    200: '#DBE2E9',
    300: '#A0AEBD',
    400: '#8D9DAD',
    500: '#555555',
    600: '#141F2B',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  background: {
    default: '#F7F9FC',
    paper: '#ffffff',
  },
  text: {
    primary: '#141F2B',
    secondary: '#555555',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  divider: '#B5B5B5',
};

export default palette;
